import React, {Component} from "react";
// import Joi from "joi-browser";
import Joi from "@hapi/joi";
import {dateToString, stringToDate} from "../../services/dateTimeFormat";
import {
    renderDateTimeInput,
    renderDetailTable1,
    renderInput,
    renderMultiSelectCheckbox,
    renderRadioButton,
    renderSelectByList,
    renderSelectByMap
} from "../../services/renderService";
import {getDataAndSchema} from "../../services/toolsService";

class Form extends Component {

    constructor() {
        super();
    }

    state = {
        data: {},
        errors: {}
    };
    baseInformation = {};
    schema = {};

    setDataAndSchema = () => {

        const {data: newData, schema: newSchema} = getDataAndSchema(this.baseInformation);

        this.state.data = newData;      // this.state... weil es innerhalb constructor() aufgerufen wird
        this.schema = newSchema;

    }

    validate = () => {
        const options = {abortEarly: false};
        const {error} = Joi.object(this.schema).validate(this.state.data, options);
        if (!error) return null;

        const errors = {};
        for (let item of error.details) {
            errors[item.path[0]] = item.message;
        }
        return errors;
    };

    validateProperty = ({name, value}) => {
        const obj = {[name]: value};
        let newSchema = {...this.schema};
        for (const item of name.split(".")) {
            newSchema = newSchema[item];
        }

        const {error} = Joi.object({[name]: newSchema}).validate(obj);
        return error ? error.details[0].message : null;
    };

    onCancel = () => {
        this.props.handleCancel();
    }

    onSave = (data) => {
        this.props.handleSave(data);
    }

    onDelete = (data) => {
        this.props.handleDelete(data);
    }

    handleSubmit = e => {
        e.preventDefault();

        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors) return;

        this.doSubmit();
    };

    doSubmit = async () => {
        // await saveMovie(this.state.data);
        // this.props.history.push("/movies");
    };

    handleChange = ({currentTarget: input}) => {
        const errors = {...this.state.errors};
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];

        const data = this.getNewData(input.name, input.value);

        this.setState({data, errors});
    };

    handleDateTimeChange = ({currentTarget: input}) => {
        const errors = {...this.state.errors};
        const errorMessage = this.validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];

        const value = dateToString(stringToDate(input.value, "YYYY-MM-DDTHH:mm"), "YYYYMMDDHHmm")

        const data = this.getNewData(input.name, value);

        this.setState({data, errors});
    };

    simpleHandleChange = ({name, value}) => {
        const data = {...this.state.data};
        data[name] = value;

        this.setState({data});
    };

    getNewData = (inputName, inputValue) => {

        const newData = {...this.state.data};
        const splitItems = inputName.split(".")

        switch (splitItems.length) {
            case 1:
                newData[splitItems[0]] = inputValue;
                break;
            case 2:
                newData[splitItems[0]][splitItems[1]] = inputValue;
                break;
            case 3:
                newData[splitItems[0]][splitItems[1]][splitItems[2]] = inputValue;
                break;
            case 4:
                newData[splitItems[0]][splitItems[1]][splitItems[2]][splitItems[3]] = inputValue;
                break;
            case 5:
                newData[splitItems[0]][splitItems[1]][splitItems[2]][splitItems[3]][splitItems[4]] = inputValue;
                break;
        }

        return newData;

    }

    getValue = (data, configuration) => {
        // console.log("Form.getValue(): data=", data)
        // console.log("Form.getValue(): configuration=", configuration)
        let dataValue = {...data}
        for (const item of configuration.name.split(".")) {
            dataValue = dataValue[item];
        }
        return dataValue;
    }

    renderCard = (heading, fieldList) => {

        let counter = 0;

        return (
            <div className="card">
                {(heading && heading.length > 0 &&
                    <div className="card-header">
                        {heading}
                    </div>
                )}
                <div className="card-body">
                    {
                        fieldList.map(item =>
                            this.renderField({key: counter++, ...item})
                        )}
                </div>
            </div>

        )
    }

    renderField = ({name, ...rest}) => {
        const {data, errors} = this.state;
        const {baseInformation} = this;
        let renderInformation = {...baseInformation};
        for (const item of name.split(".")) {
            renderInformation = renderInformation[item];
        }
        if (!renderInformation.render)
            return null;

        const configuration = {"name": name, ...rest, ...renderInformation.render.configuration};
        switch (renderInformation.render.type) {
            case "input":
                return renderInput(configuration, this.getValue(data, configuration), errors, this.handleChange)
            case "dateTimeInput":
                return renderDateTimeInput(configuration, this.getValue(data, configuration), errors, this.handleDateTimeChange)
            case "selectByList":
                return renderSelectByList(configuration, this.getValue(data, configuration), errors, this.handleChange)
            case "selectByMap":
                return renderSelectByMap(configuration, this.getValue(data, configuration), errors, this.handleChange)
            case "multiSelectCheckbox":
                return renderMultiSelectCheckbox(configuration, this.getValue(data, configuration), errors, this.handleChange)
            case "radioButton":
                return renderRadioButton(configuration, this.getValue(data, configuration), errors, this.handleChange)
            case "detailTable1":
                return renderDetailTable1(configuration, renderInformation.baseInformation, this.getValue(data, configuration), errors)
        }
        return null;

    }

    renderButton(configuration) {
        const {disabled, onClick, label, ...rest} = configuration;
        let newClassName = "btn-primary";
        if (rest["className"])
            newClassName = rest["className"];

        return (
            <div className="btn-group mr-2" role="group">
                <button
                    className={"btn " + newClassName}
                    disabled={disabled ? disabled : null}
                    onClick={onClick}
                    {...rest}
                >
                    {label}
                </button>
            </div>
        );
    }

    renderCancelButton(configuration) {
        const {label, ...rest} = configuration;
        let newLabel = label;
        if (!newLabel)
            newLabel = "Abbrechen";
        return (
            <button
                className="btn btn-info"
                onClick={() => this.onCancel()}
                {...rest}
            >
                {newLabel}
            </button>
        );
    }

    renderSaveButton(configuration) {
        const {label, ...rest} = configuration;
        let newLabel = label;
        if (!newLabel)
            newLabel = "Speichern";
        return (
            <button
                className="btn btn-primary"
                onClick={() => this.onSave(this.state.data)}
                disabled={this.validate()}
                {...rest}
            >
                {newLabel}
            </button>
        );
    }

    renderDeleteButton(configuration) {
        const {label, ...rest} = configuration;
        let newLabel = label;
        if (!newLabel)
            newLabel = "Löschen";
        return (
            <button
                className="btn btn-danger"
                onClick={() => this.onDelete(this.state.data)}
                disabled={this.validate()}
                {...rest}
            >
                {newLabel}
            </button>
        );
    }


    // renderDatePicker(configuration) {
    //     // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
    //     // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden
    //
    //     const {data} = this.state;
    //
    //     return (
    //         data &&
    //         configuration.name &&
    //         data[configuration.name] && (
    //             <DatePicker
    //                 name={configuration.name}
    //                 label={configuration.label ? configuration.label : ""}
    //                 value={this.getValue(data, configuration)}
    //                 // error={errors[configuration.name]}
    //                 onSimpleChange={this.simpleHandleChange}
    //                 help={configuration.help ? configuration.help : null}
    //                 // autoFocus={configuration.autofocus ? configuration.autofocus : null}
    //                 disabled={configuration.disabled ? configuration.disabled : null}
    //             />
    //         )
    //     );
    // }
    //
    // renderTimeKeeper(configuration) {
    //     // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
    //     // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden
    //
    //     const {data} = this.state;
    //
    //     return (
    //         data &&
    //         configuration.name &&
    //         data[configuration.name] && (
    //             <TimeKeeper
    //                 name={configuration.name}
    //                 label={configuration.label ? configuration.label : ""}
    //                 value={this.getValue(data, configuration)}
    //                 // error={errors[configuration.name]}
    //                 onSimpleChange={this.simpleHandleChange}
    //                 help={configuration.help ? configuration.help : null}
    //                 // autoFocus={configuration.autofocus ? configuration.autofocus : null}
    //                 // disabled={configuration.disabled ? configuration.disabled : null}
    //             />
    //         )
    //     );
    // }

}

export default Form;
